import React, { useCallback, memo } from 'react'
import styled from 'styled-components'
import Input from '@sl/ui-library/molecules/Input'
import axios from 'axios'

const mailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/gim
const checkMail = val => val.toLowerCase().match(mailRegexp) !== null

const checkECRM = val => axios.post(`/ser/api/partner/email-validation?email=${val}`, { email: val }, { headers: { 'Content-Type': 'application/json' } })

const MailInput = ({ state, setState }) => {
  const { clicked, valid, value } = state.userMail
  const handleInput = useCallback(e => {
    const event = e
    const newVal = e.target.value || ''
    switch (event.type) {
      case 'click':
      case 'focus':
        setState(prev => ({
          ...prev,
          userMail: {
            ...prev.userMail,
            clicked: true,
          },
        }))
        break
      case 'blur':
        if (checkMail(newVal)) {
          checkECRM(newVal)
            .then(res => {
              setState(prev => ({
                ...prev,
                userMail: {
                  ...prev.userMail,
                  valid: res.data,
                },
              }))
            })
            .catch(() => {
              setState(prev => ({
                ...prev,
                userMail: {
                  ...prev.userMail,
                  valid: checkMail(prev.userMail.value),
                },
              }))
            })
        }
        break

      case 'change':
        setState(prev => ({
          ...prev,
          userMail: {
            ...prev.userMail,
            valid: false,
            value: newVal,
          },
        }))
        break
      default:
        break
    }
  }, [])
  const content = (
    <>
      <StyledInput
        id="MooveFormLandingMailInput"
        onChange={handleInput}
        onBlur={handleInput}
        onClick={handleInput}
        onFocus={handleInput}
        error={clicked && !valid}
        success={valid}
        value={value}
        type="mail"
        label="Email"
        message="Adresse e-mail non valide"
        style={{ width: '100%' }}
      />
    </>
  )
  return content
}

const StyledInput = styled(Input)`
  > span {
    top: 100%;
  }
`

export default memo(MailInput)
